import type { AppPromotionSettings } from '@/config/appPromotion';

export type AppStoreKey = keyof AppPromotionSettings['storeUrls'];

export function getAppStoreUrl(value: unknown, store: AppStoreKey): string | null {
  if (typeof value !== 'string' || !value || value.length > 2048
    || /[\s\\<>"{}|^`]/.test(value) || /%(?![\da-f]{2})/i.test(value)) return null;

  const officialAddress = store.endsWith('GooglePlay')
    ? /^https:\/\/play\.google\.com(?::\d+)?(?:[/?#]|$)/i
    : /^https:\/\/(?:apps|itunes)\.apple\.com(?::\d+)?(?:[/?#]|$)/i;
  if (!officialAddress.test(value)) return null;

  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    const listing = store.endsWith('GooglePlay')
      ? url.pathname === '/store/apps/details' && /^[A-Za-z][A-Za-z0-9_]*(\.[A-Za-z][A-Za-z0-9_]*)+$/.test(url.searchParams.get('id') || '')
      : /^\/(?:[A-Za-z]{2}\/)?app\/(?:[^/]+\/)?id[0-9]+\/?$/.test(url.pathname);
    return listing ? value : null;
  } catch {
    return null;
  }
}
